import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from '@rsos/components/capstone/base/Checkbox';
import {
  STATIC_LAYERS_CARD,
  closeCard,
  setMapCardData,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import { toggleSpatialLayerGroup } from '../../actions/spatialLayers';
import { toggleGroupCheckboxTracking } from './mapLayersControlTrackings';

/**
 * Component for handling a group of layers under 1 checkbox
 * @param {Object} group - group of spatial layers
 */
export default ({ group = {} }) => {
  const dispatch = useDispatch();
  const layerData = useSelector(state => state.mapCard?.mapCardData?.layerData);
  const { irpVersion } = useSelector(state => state.sinatra.irp);

  const layers = group.layers || [];
  const isAnyLayerChecked = !!layers.find(i => i.layer.isChecked);
  const groupLayerName = group.name;
  const layersKeys = layers.map(l => l.key);

  const handleCheckboxOnChange = useCallback(() => {
    if (layers.find(i => i.layer.source === layerData?.source)) {
      dispatch(closeCard(STATIC_LAYERS_CARD));
      dispatch(setMapCardData(null));
    }
    dispatch(toggleSpatialLayerGroup(layersKeys));
    toggleGroupCheckboxTracking(isAnyLayerChecked, groupLayerName, irpVersion);
  }, [group]);

  return (
    <Checkbox
      key={group.id}
      label={groupLayerName}
      isChecked={isAnyLayerChecked}
      onChange={handleCheckboxOnChange}
    />
  );
};
